import { parseWreckContent } from './schema';

export const LAST_WRECK_CONTENT = parseWreckContent({
  id: 'last-wreck',
  contractTitle: 'Recover the navigation core',
  requiredSalvageId: 'navigation-core',
  extractionRoomId: 'docking-throat',
  rooms: [
    {
      id: 'docking-throat',
      name: 'Docking throat',
      index: 1,
      pressure: 'pressurized',
      bus: null,
      position: { x: 0, y: 1 },
      tutorial: true,
    },
    {
      id: 'maintenance-access',
      name: 'Maintenance access',
      index: 2,
      pressure: 'pressurized',
      bus: null,
      position: { x: 1, y: 1 },
      tutorial: true,
    },
    {
      id: 'crew-corridor',
      name: 'Crew corridor',
      index: 3,
      pressure: 'vacuum',
      bus: 'A',
      position: { x: 2, y: 1 },
      tutorial: false,
    },
    {
      id: 'power-control',
      name: 'Power control',
      index: 4,
      pressure: 'pressurized',
      bus: null,
      position: { x: 3, y: 2 },
      tutorial: false,
    },
    {
      id: 'cargo-blister',
      name: 'Cargo blister',
      index: 5,
      pressure: 'pressurized',
      bus: 'A',
      position: { x: 4, y: 2 },
      tutorial: false,
    },
    {
      id: 'navigation-chamber',
      name: 'Navigation chamber',
      index: 6,
      pressure: 'pressurized',
      bus: 'B',
      position: { x: 5, y: 1 },
      tutorial: false,
    },
    {
      id: 'observation-dome',
      name: 'Observation dome',
      index: 7,
      pressure: 'pressurized',
      bus: 'B',
      position: { x: 4, y: 0 },
      tutorial: false,
    },
    {
      id: 'service-shaft',
      name: 'Service shaft',
      index: 8,
      pressure: 'vacuum',
      bus: 'A',
      position: { x: 2, y: 0 },
      tutorial: false,
    },
  ],
  connections: [
    {
      id: 'tutorial-hatch',
      from: 'docking-throat',
      to: 'maintenance-access',
      kind: 'cut',
      bus: null,
      initiallyOpen: false,
      normal: { x: 1, y: 0 },
      structuralEvent: null,
    },
    {
      id: 'maintenance-corridor',
      from: 'maintenance-access',
      to: 'crew-corridor',
      kind: 'open',
      bus: null,
      initiallyOpen: true,
      normal: { x: 1, y: 0 },
      structuralEvent: 'narrow-at-35',
    },
    {
      id: 'corridor-power',
      from: 'crew-corridor',
      to: 'power-control',
      kind: 'door',
      bus: null,
      initiallyOpen: true,
      normal: { x: 1, y: 0 },
      structuralEvent: null,
    },
    {
      id: 'power-cargo',
      from: 'power-control',
      to: 'cargo-blister',
      kind: 'open',
      bus: null,
      initiallyOpen: true,
      normal: { x: 1, y: 0 },
      structuralEvent: null,
    },
    {
      id: 'cargo-navigation',
      from: 'cargo-blister',
      to: 'navigation-chamber',
      kind: 'door',
      bus: 'A',
      initiallyOpen: false,
      normal: { x: 1, y: 0 },
      structuralEvent: 'collapse-at-65',
    },
    {
      id: 'navigation-observation',
      from: 'navigation-chamber',
      to: 'observation-dome',
      kind: 'open',
      bus: null,
      initiallyOpen: true,
      normal: { x: -1, y: -1 },
      structuralEvent: null,
    },
    {
      id: 'observation-service',
      from: 'observation-dome',
      to: 'service-shaft',
      kind: 'cut',
      bus: null,
      initiallyOpen: false,
      normal: { x: -1, y: 0 },
      structuralEvent: null,
    },
    {
      id: 'service-dock',
      from: 'service-shaft',
      to: 'docking-throat',
      kind: 'door',
      bus: 'A',
      initiallyOpen: false,
      normal: { x: -1, y: 1 },
      structuralEvent: null,
    },
    {
      id: 'corridor-navigation-shortcut',
      from: 'crew-corridor',
      to: 'navigation-chamber',
      kind: 'cut',
      bus: null,
      initiallyOpen: false,
      normal: { x: 1, y: 0 },
      structuralEvent: null,
    },
  ],
  salvage: [
    {
      id: 'navigation-core',
      name: 'Navigation core',
      roomId: 'navigation-chamber',
      mass: 12,
      baseValue: 1200,
      fragility: 0.5,
      required: true,
      optionalClass: null,
      attachmentIds: ['core-bolt-port', 'core-bolt-starboard'],
      hidden: false,
    },
    {
      id: 'data-prism',
      name: 'Data prism',
      roomId: 'observation-dome',
      mass: 4,
      baseValue: 700,
      fragility: 0.9,
      required: false,
      optionalClass: 'precision',
      attachmentIds: ['prism-catch'],
      hidden: false,
    },
    {
      id: 'reactor-plate',
      name: 'Reactor plate',
      roomId: 'cargo-blister',
      mass: 28,
      baseValue: 900,
      fragility: 0.1,
      required: false,
      optionalClass: 'heavy',
      attachmentIds: ['plate-clamp'],
      hidden: false,
    },
    {
      id: 'medical-case',
      name: 'Medical case',
      roomId: 'crew-corridor',
      mass: 7,
      baseValue: 350,
      fragility: 0.5,
      required: false,
      optionalClass: 'field',
      attachmentIds: [],
      hidden: false,
    },
    {
      id: 'tool-cassette',
      name: 'Tool cassette',
      roomId: 'maintenance-access',
      mass: 5,
      baseValue: 250,
      fragility: 0.15,
      required: false,
      optionalClass: 'field',
      attachmentIds: [],
      hidden: false,
    },
    {
      id: 'flight-recorder',
      name: 'Flight recorder',
      roomId: 'service-shaft',
      mass: 9,
      baseValue: 500,
      fragility: 0.5,
      required: false,
      optionalClass: 'precision',
      attachmentIds: ['recorder-panel'],
      hidden: true,
    },
  ],
  cutPoints: [
    {
      id: 'tutorial-hatch-seam',
      roomId: 'docking-throat',
      target: { kind: 'connection', connectionId: 'tutorial-hatch' },
      durationSeconds: 1.8,
      heatRate: 0.34,
      coolRate: 0.5,
      heatLimit: 1,
      fragility: 0.1,
    },
    {
      id: 'shortcut-seam',
      roomId: 'crew-corridor',
      target: { kind: 'connection', connectionId: 'corridor-navigation-shortcut' },
      durationSeconds: 4,
      heatRate: 0.3,
      coolRate: 0.38,
      heatLimit: 1,
      fragility: 0.5,
    },
    {
      id: 'service-seam',
      roomId: 'observation-dome',
      target: { kind: 'connection', connectionId: 'observation-service' },
      durationSeconds: 3.2,
      heatRate: 0.28,
      coolRate: 0.4,
      heatLimit: 1,
      fragility: 0.35,
    },
    {
      id: 'core-bolt-port',
      roomId: 'navigation-chamber',
      target: { kind: 'salvage', salvageId: 'navigation-core' },
      durationSeconds: 1.6,
      heatRate: 0.36,
      coolRate: 0.48,
      heatLimit: 1,
      fragility: 0.45,
    },
    {
      id: 'core-bolt-starboard',
      roomId: 'navigation-chamber',
      target: { kind: 'salvage', salvageId: 'navigation-core' },
      durationSeconds: 1.6,
      heatRate: 0.36,
      coolRate: 0.48,
      heatLimit: 1,
      fragility: 0.45,
    },
    {
      id: 'prism-catch',
      roomId: 'observation-dome',
      target: { kind: 'salvage', salvageId: 'data-prism' },
      durationSeconds: 1.2,
      heatRate: 0.42,
      coolRate: 0.52,
      heatLimit: 1,
      fragility: 0.95,
    },
    {
      id: 'plate-clamp',
      roomId: 'cargo-blister',
      target: { kind: 'salvage', salvageId: 'reactor-plate' },
      durationSeconds: 2.4,
      heatRate: 0.3,
      coolRate: 0.45,
      heatLimit: 1,
      fragility: 0.1,
    },
    {
      id: 'recorder-panel',
      roomId: 'service-shaft',
      target: { kind: 'salvage', salvageId: 'flight-recorder' },
      durationSeconds: 2.2,
      heatRate: 0.32,
      coolRate: 0.44,
      heatLimit: 1,
      fragility: 0.4,
    },
  ],
  tuning: {
    scanCooldownSeconds: 1.2,
    scanRevealSeconds: 8,
    grappleRange: 140,
    grappleWarningTension: 12,
    cableBreakMultiplier: 1.2,
    baseInstabilityPerSecond: 0.075,
    emergencySeconds: 20,
  },
});
